import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWallet,
  faChartBar,
  faChartLine,
  faDollarSign,
  faEye,
  faEyeSlash,
  faArrowTrendUp, // ✅ required
  faArrowTrendDown, // ✅ required
  faPlus,
  faPen,
} from "@fortawesome/free-solid-svg-icons";


const BalanceCard2 = () => {
  return (
    <div
      className="container-fluid p-4"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)",
        border: "1px solid #23272f",
        color: "#fff",
        borderRadius: "12px",
        maxWidth: "500px",
        margin: "auto",
      }}
    >
      <div
        className="card p-4"
        style={{
          background: "#18181b",
          borderRadius: "12px",
          border: "1px solid #23272f",
        }}
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          
        <div className="d-flex align-items-center">
  <div
    className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-2"
    style={{
      background: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
      width: "30px",
      height: "30px",
      boxShadow: "0 2px 8px 0 rgba(37,99,235,0.12)",
    }}
  >
    <FontAwesomeIcon
      icon={faWallet}
      style={{ fontSize: "15px", color: "#fff" }}
    />
  </div>
  
  <div>
    <h5 className="text-white fw-bold">My Balance</h5>
  </div>
</div>

                 
           
          <Dropdown>
            <Dropdown.Toggle
              variant="secondary"
              id="dropdown-basic"
              style={{
                backgroundColor: "black",
                border: "none",
                color: "#fff",
              }}
            >
              BTH
            </Dropdown.Toggle>
            <Dropdown.Menu
              style={{
                background: "black",
                color: "white",
              }}
            >
              <Dropdown.Item className="text-white" href="#">BTH</Dropdown.Item>
              <Dropdown.Item className="text-white" href="#">ETH</Dropdown.Item>
              <Dropdown.Item className="text-white" href="#">BTC</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Balance Section */}
        <div className="mb-3">
          <h3 className="fw-bold text-white">$4,472.90</h3>
        </div>

        {/* Details */}
        <div className="rounded-3 p-3 mb-4 d-flex justify-content-between"  style={{
          background: "#1d2223",
          borderRadius: "12px",
          border: "1px solid #23272f",
        }}>
          <div className="px-2 border-top-0 border-bottom-0 border-start-0 border-2 border border-secondary">
            <span className="text-secondary fw-bold">Total Profit</span>
            <h4 className="text-white fw-bold mt-2">+ $2,463.20</h4>
          </div>
          <div className="px-2 border-top-0 border-bottom-0 border-start-0 border-2 border border-secondary">
            <span className="text-secondary fw-bold">Avg. Growing</span>
            <h4 className="text-white fw-bold mt-2">+14.63%</h4>
          </div>
          <div className="px-2 border-top-0 border-bottom-0 border-start-0 border-2 border border-secondary">
            <span className="text-secondary fw-bold">Best Token</span>
            <h4 className="text-white fw-bold mt-2">Bitcoin</h4>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-between">
          <button
            className="btn"
            style={{
              backgroundColor: "#22c55e",
              color: "#fff",
              borderRadius: "8px",
              width: "48%",
            }}
          >
            Withdraw
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: "#ef4444",
              color: "#fff",
              borderRadius: "8px",
              width: "48%",
            }}
          >
            Transfer
          </button>
        </div>
      </div>
    </div>
  );
};

export default BalanceCard2;
